<template>
  <div>
    <h3>Total Recruiters: {{ pagination.totalItems }}</h3>

    <filters />

    <el-table
      class="cursor-pointer"
      border
      :data="recruitersData"
      highlight-current-row
      @row-click="handleClickRow"
    >
      <el-table-column
        width="64px"
        prop="activated"
        label="Active"
      >
        <template slot-scope="scope">
          <activated-icon :is-activated="scope.row.activated" />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasOrigin"
        width="64px"
        prop="origin"
        label="Origin"
      >
        <div
          v-if="scope.row.origin"
          slot-scope="scope"
        >
          <origin-icon :origin="scope.row.origin.name" />
        </div>
      </el-table-column>
      <el-table-column
        prop="firstName"
        label="First Name"
      />
      <el-table-column
        prop="lastName"
        label="Last Name"
      />
      <el-table-column
        prop="email"
        label="Email"
      />
      <el-table-column
        width="72px"
        prop="gender"
        label="Gender"
      >
        <div
          slot-scope="scope"
          class="text-center"
        >
          <gender-icon :gender="scope.row.gender" />
        </div>
      </el-table-column>
      <el-table-column
        prop="profile.createdDate"
        label="Date Created"
      >
        <template slot-scope="scope">
          {{ displayDate(scope.row.createdDate) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="location.name"
        label="Location"
      >
        <template slot-scope="scope">
          {{ (scope.row.location && scope.row.location.name) | NA | ucwords }}
        </template>
      </el-table-column>
      <el-table-column
        prop="educationLevel"
        label="Education Level"
      >
        <template slot-scope="scope">
          {{ scope.row.educationLevel | NA | removeDashes | ucwords }}
        </template>
      </el-table-column>
      <el-table-column
        prop="birthInfo"
        label="Date of Birth"
      >
        <template slot-scope="scope">
          {{ birthDate(scope.row.birthInfo.day, scope.row.birthInfo.month, scope.row.birthInfo.year) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="profile.status"
        width="80px"
        label="Status"
      >
        <template slot-scope="scope">
          <span :class="scope.row.profile.status">
            <strong>{{ scope.row.profile.status }}</strong>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="profile.trialExtended"
        label="Trial Extended"
      >
        <template slot-scope="scope">
          <activated-icon :is-activated="scope.row.profile.trialExtended" :activatedText="'Trial has been extended'" :notActivatedText="'Trial has NOT been extended'" />
        </template>
      </el-table-column>
      <el-table-column
        prop="profile.turkish"
        label="Turkish Account"
        v-if="!isTurkish"
      >
        <template slot-scope="scope">
          <activated-icon :is-activated="scope.row.profile.turkish" :activatedText="'This is a Turkish Account'" :notActivatedText="'This is NOT a Turkish Account'" />
        </template>
      </el-table-column>
      <el-table-column
        prop="profile.expirationDate"
        label="Expiration Date"
      >
        <template slot-scope="scope">
          {{ displayDate(scope.row.profile.expirationDate) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="has-top-padding is-centered"
      background
      layout="prev, pager, next"
      :page-size="pagination.pageSize"
      :total="pagination.totalItems"
      @current-change="changePaginationPage"
    />

    <UserDrawer
      :show-panel="enablePanel"
      :user="currentRow"
      :is-recruiter="true"
      @close="handleClosePanel()"
    />
  </div>
</template>

<script>
import debounce from 'debounce-promise'
import Filters from '@/components/Filters/Filters'
import UserDrawer from '@/components/UserDrawer/UserDrawer'
import GenderIcon from '@/components/GenderIcon/GenderIcon'
import ActivatedIcon from '@/components/ActivatedIcon/ActivatedIcon'
import OriginIcon from '@/components/OriginIcon/OriginIcon'
import { GlobalEmitter } from '@/utils/GlobalEmitter'

export default {
  name: 'Recruiters',
  components: {
    Filters,
    UserDrawer,
    GenderIcon,
    ActivatedIcon,
    OriginIcon
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 12,
        totalItems: 0
      },
      enablePanel: false,
      currentRow: {
        profile: {}
      }
    }
  },
  computed: {
    requestQueryParams() {
      return this.$store.getters['filters/requestQueryParams']
    },

    isTurkish() {
      return this.$store.getters.isTurkish
    },

    recruitersData() {
      return this.$store.getters.recruitersData
    },

    hasOrigin() {
      let hasOrigin = false

      this.recruitersData.forEach(item => {
        if (item.origin && item.origin.name) {
          hasOrigin = true
          return true
        }
      })

      return hasOrigin
    }
  },
  watch: {
    requestQueryParams() {
      this.getRecruitersDebounce(this)
    }
  },
  async created() {
    GlobalEmitter.$on('resetView', async(dt) => {   
      this.pagination = {
        currentPage: 1,
        pageSize: 12,
        totalItems: 0
      }
      this.$store.commit("filters/reset")
    })

    GlobalEmitter.$on('reloadView', async(dt) => {
      console.log('here')
      await this.getRecruiters()
    })
    await this.getRecruiters()
  },
  methods: {
    handleClickRow(row) {
      this.currentRow = row
      this.enablePanel = true
    },

    handleClosePanel() {
      this.enablePanel = false
    },

    changePaginationPage(page) {
      this.pagination.currentPage = page
      this.getRecruiters()
    },

    getRecruitersDebounce: debounce(vm => {
      vm.pagination.currentPage = 1
      vm.getRecruiters()
    }, 400),

    getRecruiters() {
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize,
        ...this.requestQueryParams
      }

      this.$store.dispatch('getRecruiters', { params })
        .then(res => {
          const pagination = this.$store.getters.recruitersPaginationData

          this.pagination.currentPage = pagination.currentPage
          this.pagination.totalItems = pagination.totalItems
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~vars";

.PAID {
  color: $-color-success;
}
.FREE {
  color: $-color-warning;
}
.EXPIRED {
  color: $-color-error;
}
</style>
